import * as React from "react";
import './FormFinish.css';
// @ts-ignore
import DEFAULT_FINISH_IMG from "../../../../../assets/images/megaphone_bear.svg";
import NavigationConstants from "../../../../Navigation/NavigationConstants";
import {RouteComponentProps} from "react-router";
import MixPanelAnalyticsService from "../../../../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsSignUpEvents} from "../../../../../services/Analytics/AnalyticsSignUpEvents";
import GoogleAnalyticsService from "../../../../../services/Analytics/GoogleAnalyticsService";
import FBPixelService from "../../../../../services/Analytics/FBPixelService";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";

interface IProps extends RouteComponentProps<any>{
    finishImg? : any
    link?: string
    isCancel?: boolean,
    store?: any,
    newPlanRequest?: boolean,
    isUpgrade?: boolean,
    isPartner?: boolean
    isUpdate?: boolean;
    isReplaceCard?: boolean
    isWWDemo?: boolean
}

export default class FormFinish  extends React.Component<
    IProps
    > {
    constructor (props: IProps) {
        super(props);
        this.triggerAnalytics();
    }

    public getHeaderText = () => {
        const {newPlanRequest, isCancel, isUpgrade, isPartner, isReplaceCard} = this.props;
        if (isCancel) {return <div className="header"> Your request was received </div>}
        else if(isUpgrade) {return <div className="header">Your request is under review</div>}
        else if(newPlanRequest) {return <div className="header">Your application is now under review</div>}
        else if (isPartner) {return <div className="header">Your application is now under review</div>}
        else if(isReplaceCard) {return <div className="header">Yay!</div>}
        else {
            return this.getTextByApplicationTypeAndStatus();
        }
    };

    public getSubHeaderText = () => {
        const {isCancel, store, newPlanRequest, isUpgrade, isPartner, isReplaceCard} = this.props;
        if (isCancel || newPlanRequest || isUpgrade || isPartner) {
            return <div>Our team will reach out to you within 24 hours</div>
        }else if(isReplaceCard) {return <div>You successfully updated your payment method.</div>}
        else {
            return store && store.isVerified?  <div className="sub-header">Check your inbox, we're getting our ducks in a row.</div> : <div className="sub-header">Our dedicated team will contact you within 1 business day.</div>;
        }
    };

    public closeWindow = () => {
        const {history} = this.props;
        history.replace(NavigationConstants.myAccount);
    };

    public render() {
        const {link} = this.props;
        const headerText = this.getHeaderText();
        const subheaderText = this.getSubHeaderText();
        return (
                <div className="container">
                    <div className="text">
                        {headerText}
                        {subheaderText}
                        {link?<div className="salaryo-link"> <a href={link}> {link.replace("http://", "")} </a></div>: null }
                    </div>
                </div>
        );
    };

    private getTextByApplicationTypeAndStatus = () => {
        const {store} = this.props;
        if(store.formInput.isApprovedApplication) {
            return <div className="header">Woohoo! <br/> Your application was approved</div>;
        }else {
            return store && store.isVerified?  <div className="header">Woohoo! <br/> Your application was approved</div> : <div className="header">Well done! <br/> Your application is under review</div>;
        }
    };

    private getFBEventName = (): string | null => {
        const {store} = this.props;
        if(!store || !store.formInput.plans) {
            return null
        }
        const plan = store.formInput.plans.plansValue;
        switch (plan) {
            case LeadPlanType.Rent: return "Rent application";
            case LeadPlanType.Loan: return "Business loan application";
            case LeadPlanType.Deposit: return "Deposit application";
            case LeadPlanType.DepositRent: return "Rent+deposit application";
            default: return ""
        }
    };

    private triggerAnalytics = () => {
        MixPanelAnalyticsService.track(AnalyticsSignUpEvents.ApplicationCompleted);
        GoogleAnalyticsService.triggerEvent("Signup","Form submission", "Application completed");
        const eventName = this.getFBEventName();
        if(eventName) {
            FBPixelService.track(eventName);
        }
    }
}




// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormFinish/FormFinish.tsx